import { Check } from '@phosphor-icons/react';

export default Check;
